import { render } from "./PersonaDetalleEng.vue?vue&type=template&id=2f17473c"
import script from "./PersonaDetalleEng.vue?vue&type=script&lang=js"
export * from "./PersonaDetalleEng.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__